import _ from "lodash";

const forwardFormatError = "FORWARD_ERROR_MSG";
const forwardUnsetError = "FORWARD_UNSET_MSG";

export default class CallMgtModalController {
  constructor(
    $scope,
    $uibModalInstance,
    $uibModal,
    forward,
    XucUtils,
    XucUser,
    CtiProxy,
    electronWrapper,
    XucPhoneState,
    UserPreferenceService,
    toast,
    $translate
  ) {
    this.$scope = $scope;
    this.$uibModal = $uibModal;
    this.forward = forward;
    this.XucUtils = XucUtils;
    this.CtiProxy = CtiProxy;
    this.UserPreferenceService = UserPreferenceService;
    this.electronWrapper = electronWrapper;
    this.XucPhoneState = XucPhoneState;
    this.uaDeviceSelected = "";
    this.calls = XucPhoneState.getCalls();
    this.isUsingMobileApp = CtiProxy.isUsingMobileApp();
    $scope.uncFwdError = false;
    $scope.naFwdError = false;
    $scope.uncFwdMessage = forwardFormatError;
    $scope.naFwdMessage = forwardFormatError;
    $scope.currentUser = _.clone(XucUser.getUser());
    this.userPreferenceModel = {};
    this.toast = toast;
    this.translate = $translate;

    if (
      $scope.currentUser.uncFwdDestination === "" ||
      $scope.currentUser.uncFwdDestination === "null"
    ) {
      $scope.currentUser.uncFwdDestination = "";
    }

    if (
      $scope.currentUser.naFwdDestination === "" ||
      $scope.currentUser.naFwdDestination === "null"
    ) {
      $scope.currentUser.naFwdDestination = "";
    }
    this.setUaDeviceSelected(UserPreferenceService.getPreferredDevice(true));

    this.userPreferenceModel = Object.assign(
      {},
      this.UserPreferenceService.getPrefferedDeviceModel(
        this.mobileAppIsActivated(),
        this.isUniqueAccount()
      )
    );

    $scope.close = () => {
      $uibModalInstance.close();
    };

    $uibModalInstance.result.then(
      () => {},
      () => {
        $scope.close();
      }
    );

    $scope.$watch(
      () => {
        return this.uaDeviceSelected;
      },
      (newValue, oldValue) => {
        if (oldValue !== undefined && oldValue !== newValue) {
          CtiProxy.toggleUniqueAccountDevice(newValue);
        }
      }
    );


    $scope.$on(UserPreferenceService.USER_PREFERENCES_UPDATE, () => {
      this.userPreferenceModel = Object.assign(
        {},
        this.UserPreferenceService.getPrefferedDeviceModel(
          this.mobileAppIsActivated(),
          this.isUniqueAccount()
        )
      );
      if(!$scope.$$phase) $scope.$apply();
    });
  }

  mobileAppIsActivated() {
    return this.CtiProxy.isUsingMobileApp();
  }

  isUniqueAccount() {
    return this.CtiProxy.isUsingUa();
  }

  // "Renvoyer tous les appels" and "Renvoyer sur non-réponse" are mutually
  // exclusive: forwarding every call already covers the no-answer case, so
  // enabling one locally disables the other immediately.
  toggleUncFwd() {
    const user = this.$scope.currentUser;

    this.toggle("uncFwd", user);
    if (user.uncFwdEnabled && user.naFwdEnabled) {
      this.toggle("naFwd", user);
      this.$scope.naFwdError = false;
      this.forward.setNaFwd(user);
    }
    this.$scope.uncFwdError = false;

    if (!user.uncFwdEnabled) {
      this.forward.setUncFwd(user);
    } else {
      this.focusField("forward-unc-dest");
      if (this.validatePhoneNb(user.uncFwdDestination)) {
        this.forward.setUncFwd(user);
      }
    }
  }

  toggleNaFwd() {
    const user = this.$scope.currentUser;

    this.toggle("naFwd", user);
    if (user.naFwdEnabled && user.uncFwdEnabled) {
      this.toggle("uncFwd", user);
      this.$scope.uncFwdError = false;
      this.forward.setUncFwd(user);
    }
    this.$scope.naFwdError = false;

    if (!user.naFwdEnabled) {
      this.forward.setNaFwd(user);
    } else {
      this.focusField("forward-na-dest");
      if (this.validatePhoneNb(user.naFwdDestination)) {
        this.forward.setNaFwd(user);
      }
    }
  }

  // Every destination edit is saved live, as soon as it is a valid number;
  // there is no separate "save" step.
  onDestinationChange(inputType) {
    const user = this.$scope.currentUser;
    const errorKey = inputType === "uncFwd" ? "uncFwdError" : "naFwdError";
    const messageKey = inputType === "uncFwd" ? "uncFwdMessage" : "naFwdMessage";
    const destination =
      inputType === "uncFwd" ? user.uncFwdDestination : user.naFwdDestination;

    if (!destination || !destination.trim()) {
      this.$scope[errorKey] = true;
      this.$scope[messageKey] = forwardUnsetError;
      return;
    }

    if (!this.validatePhoneNb(destination)) {
      this.$scope[errorKey] = true;
      this.$scope[messageKey] = forwardFormatError;
      return;
    }

    this.$scope[errorKey] = false;
    if (inputType === "uncFwd") {
      this.forward.setUncFwd(user);
    } else {
      this.forward.setNaFwd(user);
    }
  }

  focusField(elementId) {
    _.defer(() => {
      const element = document.getElementById(elementId);
      if (element) element.focus();
    });
  }

  bannerType() {
    const user = this.$scope.currentUser;
    if (user.dndEnabled) return "dnd";
    if (user.uncFwdEnabled) return "uncFwd";
    if (user.naFwdEnabled) return "naFwd";
    return "none";
  }

  bannerActive() {
    return this.bannerType() !== "none";
  }

  bannerLabelText() {
    const type = this.bannerType();
    if (type === "none") {
      return this.bannerNoneLabel();
    }

    const key = {
      dnd: "CALL_MAN_BANNER_DND",
      uncFwd: "CALL_MAN_BANNER_UNC",
      naFwd: "CALL_MAN_BANNER_NA",
    }[type];
    return this.translate.instant(key);
  }

  // When no dnd/forwarding rule is active, calls simply go to whichever
  // device(s) are currently selected in the device-switch above (PC, mobile
  // app, deskphone) instead of a generic "your device" message.
  bannerNoneLabel() {
    if (!this.isUniqueAccount() && !this.mobileAppIsActivated()) {
      return this.translate.instant("CALL_MAN_BANNER_NONE");
    }

    const devices = [];
    if (this.userPreferenceModel.webrtc) {
      devices.push(
        this.translate.instant(
          this.isElectron() ? "WEBRTC_ELECTRON_SWITCH" : "WEBRTC_SWITCH"
        )
      );
    }
    if (this.userPreferenceModel.mobile && this.mobileAppIsActivated()) {
      devices.push(this.translate.instant("MOBILEAPP_SWITCH"));
    }
    if (this.userPreferenceModel.phone) {
      devices.push(this.translate.instant("DESKPHONE_SWITCH"));
    }

    if (devices.length === 0) {
      return this.translate.instant("CALL_MAN_BANNER_NONE");
    }

    return this.translate.instant("CALL_MAN_BANNER_DEVICES", {
      devices: devices.join(", "),
    });
  }

  bannerTail() {
    const user = this.$scope.currentUser;
    switch (this.bannerType()) {
    case "dnd":
      return this.translate.instant("CALL_MAN_BANNER_DND_TAIL");
    case "uncFwd":
      return user.uncFwdDestination
        ? this.translate.instant("CALL_MAN_BANNER_UNC_TAIL", { destination: user.uncFwdDestination })
        : this.translate.instant("CALL_MAN_BANNER_EMPTY_TAIL");
    case "naFwd":
      return user.naFwdDestination
        ? this.translate.instant("CALL_MAN_BANNER_NA_TAIL", { destination: user.naFwdDestination })
        : this.translate.instant("CALL_MAN_BANNER_EMPTY_TAIL");
    default:
      return "";
    }
  }

  toggle(inputType, user) {
    switch (inputType) {
    case "uncFwd":
      user.uncFwdEnabled = !user.uncFwdEnabled;
      break;
    case "naFwd":
      user.naFwdEnabled = !user.naFwdEnabled;
      break;
    }
  }

  processDnd(user) {
    this.forward.setDnd(user);
  }

  validatePhoneNb(phoneNb) {
    if (!phoneNb || phoneNb === "") return false;
    return this.XucUtils.isaPhoneNb(this.XucUtils.normalizePhoneNb(phoneNb));
  }

  setUaDeviceSelected(val) {
    this.uaDeviceSelected = val;
  }

  isElectron() {
    return this.electronWrapper.isElectron();
  }

  isLastCheckedThreeDevice(deviceType) {
    return this.mobileAppIsActivated() && this.isLastCheckedDevice(deviceType);
  }

  isLastCheckedDevice(deviceType) {
    const checkedDevices = Object.entries(this.userPreferenceModel).filter(
      ([, value]) => value === true
    );

    return checkedDevices.length === 1 && checkedDevices[0][0] === deviceType;
  }

  showWarnMessageInToast() {
    this.toast({
      duration: 3000,
      message: this.translate.instant("UA_FORBIDDEN_LAST_DEVICE"),
      className: "warning-toast",
      position: "center",
      container: ".modal-header",
    });
  }

  toggleOppositeDevice(deviceType) {
    const prefs = this.userPreferenceModel;
    const phoneOrMobile = this.isUniqueAccount() ? "phone" : "mobile";
    deviceType === "webrtc"
      ? (prefs[phoneOrMobile] = !prefs[phoneOrMobile])
      : (prefs.webrtc = !prefs.webrtc);
  }

  onClickDevice(deviceType) {
    if (
      this.isLastCheckedDevice(deviceType) &&
      this.isUniqueAccount() &&
      this.mobileAppIsActivated()
    ) {
      this.showWarnMessageInToast();
      return;
    }

    if (this.isLastCheckedDevice(deviceType)) {
      this.toggleOppositeDevice(deviceType);
    }

    this.userPreferenceModel[deviceType] =
      !this.userPreferenceModel[deviceType];


    if (this.isUniqueAccount()) {
      this.CtiProxy.toggleUniqueAccountDevice(
        this.UserPreferenceService.getPreferredDeviceFromModel(
          this.userPreferenceModel
        )
      );
    } else {
      this.setPreferredDevice(this.userPreferenceModel);
    }
  }

  setPreferredDevice(deviceModel) {
    this.UserPreferenceService.setPreferredDeviceFromModel(deviceModel);
  }

  canSwitchDevice() {
    return this.calls.length === 0;
  }

  deleteMobileApp() {
    this.$uibModal.open({
      templateUrl:
        "assets/javascripts/ucassistant/controllers/deleteMobileAppModal.controller.html",
      size: "sm",
      controller: "deleteMobileAppModalController",
      resolve: {},
    });
  }

  lightened() {
    return this.userPreferenceModel.mobile ? "unpair-icon-lightened" : "";
  }
}
